import $ from "jquery"

class Hamburger{    

    constructor(){

        // Menu hamburger
        this.hamburger = $('#hamburger')
        this.menu = $( '#top-nav' )    
        this.menuRs = $( '#menu-right ul' )

        // Ecouteurs
        this.hamburger.on( 'click' , e => {
            this.clickHamburger()
        })
    }

    clickHamburger(){
        this.hamburger.toggleClass('active')
        this.menu.toggleClass('active')
        this.menuRs.toggleClass('active')
        $('header').toggleClass('open')
    }

}

export { Hamburger }